import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateDataService {
  private data: any;
  private placeHolders: any

  constructor() { }

  setData(data: any, placeHolders?: any) {
    this.data = data;
    this.placeHolders = placeHolders;
  }

  getData(): any {
    return {
      data: this.data,
      placeholders: this.placeHolders
    };
  }
}
